import { FilterInput } from '@apeiron/common'
import { ApeironCloseButton } from '@apeiron/temp'
import { styled } from '@mui/material'
import { FavoriteFilter } from '@src/types/favoriteFilter'
import { MouseEvent, useCallback } from 'react'

const Item = styled('li')`
  display: flex;
  align-items: center;
  cursor: pointer;

  padding-left: 50px;
  padding-right: 16px;
  margin: 2px 0px;
  height: 25px;

  color: #333333;
  &:hover {
    background-color: #ffffff;
  }
  &.current {
    background-color: #f1b535;

    :hover {
      background-color: #f5d286;
    }
  }
`

const Name = styled('span')`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  line-height: 14px;
`

const StyledCloseButton = styled(ApeironCloseButton)`
  margin-right: 2px;
  width: 16px;
  height: 16px;
  filter: invert(45%);
  &:hover,
  &.active {
    filter: invert(52%) sepia(93%) saturate(6616%) hue-rotate(345deg);
  }
`

const SaveFilterItem = <T extends FilterInput>(props: Props<T>) => {
  const { className, savedSearch, isCurrent, onSelect, onDelete } = props

  const cls = [className, isCurrent ? 'current' : ''].filter(Boolean).join(' ')

  const onClick = useCallback(() => {
    onSelect?.(savedSearch)
  }, [onSelect, savedSearch])

  const onClickDelete = useCallback(
    (e: MouseEvent) => {
      e.stopPropagation()
      onDelete?.(savedSearch.id)
    },
    [onDelete, savedSearch]
  )

  return (
    <Item tabIndex={0} className={cls} onClick={onClick}>
      <Name>{savedSearch.name}</Name>
      <StyledCloseButton disableRipple onClick={onClickDelete} />
    </Item>
  )
}

type Props<T extends FilterInput> = {
  className?: string
  savedSearch: FavoriteFilter<T>
  isCurrent?: boolean
  onSelect?: (savedSearch: FavoriteFilter<T>) => void
  onDelete?: (id: string) => void
}

export default SaveFilterItem
